import React from 'react';

import { ReactComponent as ErrorPageIcon } from '../../assets/icons/error-page.svg';
import StyledButton from '../../shared/components/StyledButton/StyledButton';

import './styles.scss';

const ErrorPage = () => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="error-page-container">
      <ErrorPageIcon className="image" />
      <div className="error-title">Oops! The information could not be loaded</div>
      <div className="description-container">
        <div className="error-description">Please try again now or later.</div>
      </div>
      <div className="button-container">
        <StyledButton buttonType="secondary" buttonSize="lg" action={reloadPage}>
          Try again
        </StyledButton>
      </div>
    </div>
  );
};

export default ErrorPage;
